export const SHUTTERSTOCK_DIGITAL_GOODS_ID = {
  PICTURE: "31396262-3737-3438-2d31-3131312d3434",
  VIDEO: "32313337-3765-3164-2D66-6164332D3131"
};